@if(header){
<div class="info-section-header">
	{{ header }}
</div>
} @if(subheader) {
<div class="info-section-subheader">
	{{ subheader }}
	@if(displayUrl){>&nbsp;
	<a href="{{ href }}" target="_blank">{{ urlDisplayText }}</a>
	}
</div>
} @for(property of properties; track property){
<edit-item
	[parentForm]="parentForm"
	[propertyName]="property"
	[mode]="mode"
>
</edit-item>
}
